import React, { useEffect, useState } from "react";
import DateRangeSelector from "./DateRangeSelector";
import GuestSelector from "./GuestSelector";
import InfoMessage from "./InfoMessage";
import { useDetailContext } from "@/context/detailContext";
import { useRouter } from "next/router";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { calculateFunc } from "@/utils/functions/calculateFunc";
import {
  useGetAvailability,
} from "@/api/api";
import tr from "date-fns/locale/tr";
import { useGlobalContext } from "@/context/globalContext";
import dynamic from "next/dynamic";

const ReservationDetails = dynamic(() => import("./ReservationDetails"), {
  ssr: false,
});
const PaymentDetails = dynamic(() => import("./PaymentDetails"), {
  ssr: false,
});
const CallToActionButton = dynamic(() => import("./CallToActionButton"), {
  ssr: false,
});

const ReservationRequestComponent = ({
  villa,
  scrollRef,
  result,
  setResult,
}) => {
  const {
    selectedDatesFilter,
    enquiryForm,
    setEnquiryForm,
  } = useDetailContext();

  const { setMobileBar } = useGlobalContext();

  const window = useWindowDimensions();
  const router = useRouter();
  const fetchActive = window;

  const currentRoutingTypeId = "Detail";
  const [error, setError] = useState(false);
  const [promotionError, setPromotionError] = useState(null);
  const [warning, setWarning] = useState(false);
  const [promotionCode, setPromotionCode] = useState("");
  const [approvedPromotion, setApprovedPromotion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const { startDate, endDate } = selectedDatesFilter[0];

  const { data } = useGetAvailability(villa?.id);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedPromotionCode = localStorage.getItem("PromotionCode") || "";
      setPromotionCode(storedPromotionCode);
    }
  }, []);

  useEffect(() => {
    if (fetchActive && startDate.toString() != endDate.toString()) {
      calculateFunc(
        setIsLoading,
        startDate,
        endDate,
        approvedPromotion || promotionCode,
        //  localeData,
        tr,
        villa?.id,
        currentRoutingTypeId,
        setWarning,
        setError,
        setResult,
        setPromotionError
      );
    }
  }, [
    fetchActive,
    endDate,
    startDate,
    promotionCode,
    approvedPromotion,
    setError,
    setWarning,
    setResult,
    setPromotionError,
    villa?.id,
    //  localeData,
  ]);

  useEffect(() => {
    if (fetchActive) {
      // GetAvailability(villa?.id).then((e) => {
      //   setDisabledDates(e.data.data);
      // });
      setResult(false);
    }
    setEnquiryForm((prev) => {
      return { ...prev, ProductId: villa?.id };
    });
  }, [fetchActive, villa?.id]);

  const submitForm = async () => {
    const module = await import("@/utils/detailSubmitForm");
    module.detailSubmitForm({
      enquiryForm,
      villa,
      router,
      setMobileBar,
      setError,
    });
  };

  if (!villa.aktif) return;
  return (
    <div ref={scrollRef} className="flex flex-col lg:sticky top-4">
      <div className="lg:bg-[#E7EDF4] lg:rounded-2xl rounded-md px-4 py-3 lg:mb-8">
        <span className="hidden lg:block w-full pl-4 mb-3 text-xl font-medium leading-normal text-themeBlack">
          Rezervasyon Talebi
        </span>
        <div className="flex flex-col gap-2 rounded bg-white bg-opacity-50 p-2.5 mb-5">
          <DateRangeSelector
            showCalendar={showCalendar}
            setShowCalendar={setShowCalendar}
            dates={data?.data}
            setError={setError}
          />
          <GuestSelector />
        </div>
        {result?.success && (
          <div className="flex flex-col">
            <ReservationDetails price={result?.result} />
            <PaymentDetails price={result?.result} />
            <CallToActionButton
              submitForm={submitForm}
              text="Ön Rezervasyon Talebi"
            />
          </div>
        )}
        {error && <p className="mx-3 my-3 text-sm text-red-500">{error}</p>}
        {promotionError && (
          <p className="mx-3 my-3 text-sm text-red-500">{promotionError}</p>
        )}
        <InfoMessage
          iconSrc="/icons/paymentSidebar.svg"
          message={`%${villa?.depozito} şimdi, kalanı girişte öde`}
        />
      </div>
    </div>
  );
};

export default ReservationRequestComponent;
